import MerchantOnboardingBankDetailsPage from '../../../../components/merchant/onboarding-bank-details/MerchantOnboardingBankDetailsPage'

export default function BankDetails() {
  return <MerchantOnboardingBankDetailsPage />
}
